<template>
  <div id="app" class="app-container">
    <router-view/>
  </div>
</template>

<script>
export default{
  name: 'App'
}
</script>

<style>
html{
  height: 100%;
  background: #eee
}
.app-container {
  width: 100%;
  height: 100%;
}
</style>

